import React from 'react';
import { motion } from 'framer-motion';
import { useStory, STEPS } from '../../context/StoryContext';
import { api } from '../../services/api';
import BackArrow from '../ui/BackArrow';

// Nuevas URLs con fondo transparente
const TURRIS_LOGO = '/logo-turris.svg';
const MOCKUP_BOY = 'https://customer-assets.emergentagent.com/job_sant-jordi-baker/artifacts/fjownnc2_libro%203d%20nen.png';
const MOCKUP_GIRL = 'https://customer-assets.emergentagent.com/job_sant-jordi-baker/artifacts/o88y9spx_libro%203d%20noia.png';

export default function ProtagonistTypeScreen() {
  const { goToStep, goBack, setProtagonistType, setUiTexts } = useStory();

  const handleSelectType = async (type) => {
    setProtagonistType(type);
    
    try {
      const texts = await api.getUiTexts('ca');
      setUiTexts(texts);
    } catch (e) {
      console.error('Error loading texts:', e);
    }
    
    api.trackEvent('protagonist_type_selected', { type });
    goToStep(STEPS.NAME);
  };

  return (
    <div 
      className="min-h-screen flex flex-col"
      style={{ 
        background: 'linear-gradient(180deg, #FDFBF7 0%, #F6EEE3 100%)'
      }}
    >
      {/* Header */}
      <header className="p-4 sm:p-6 flex items-center justify-between">
        <BackArrow onClick={goBack} />
        <img 
          src={TURRIS_LOGO} 
          alt="Turris" 
          className="h-10 sm:h-12 drop-shadow-sm" 
        />
        <div className="w-10" />
      </header>

      {/* Progress indicator */}
      <div className="flex justify-center gap-2 py-2">
        <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: '#2A9D8F' }} />
        <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: '#D32F2F' }} />
        <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: '#E0E0E0' }} />
        <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: '#E0E0E0' }} />
        <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: '#E0E0E0' }} />
      </div>

      {/* Main content */}
      <main className="flex-1 flex flex-col items-center justify-start sm:justify-center px-4 pt-4 sm:pt-0 pb-8">
        <motion.div
          className="text-center mb-6 sm:mb-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 
            className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold mb-4"
            style={{ color: '#1a365d' }}
          >
            Qui serà el protagonista?
          </h1>
          <p 
            className="text-base sm:text-lg font-medium px-4 py-3 rounded-full inline-block"
            style={{ 
              color: '#1a365d',
              backgroundColor: 'rgba(245, 158, 11, 0.15)',
              border: '2px solid rgba(245, 158, 11, 0.3)'
            }}
          >
            👆 Tria el personatge i després posa-li el nom que vulguis
          </p>
        </motion.div>

        <div className="flex flex-col sm:flex-row gap-4 sm:gap-10 w-full max-w-2xl justify-center">
          {/* Option NOI - libro clicable */}
          <motion.button
            data-testid="protagonist-noi"
            onClick={() => handleSelectType('noi')}
            className="group flex flex-col items-center cursor-pointer"
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            whileHover={{ scale: 1.12, y: -20 }}
            whileTap={{ scale: 0.95 }}
          >
            <motion.div 
              className="relative transition-all duration-300 group-hover:brightness-110"
              style={{
                filter: 'drop-shadow(0 20px 25px rgba(0,0,0,0.25))'
              }}
            >
              {/* Glow effect behind the book */}
              <div 
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 blur-2xl -z-10"
                style={{
                  background: 'radial-gradient(circle, rgba(245, 158, 11, 0.5) 0%, transparent 70%)',
                  transform: 'scale(1.3)'
                }}
              />
              <img
                src={MOCKUP_BOY}
                alt="Protagonista noi"
                className="w-36 sm:w-52 lg:w-64 transition-all duration-300"
              />
            </motion.div>
          </motion.button>

          {/* Option NOIA - libro clicable */}
          <motion.button
            data-testid="protagonist-noia"
            onClick={() => handleSelectType('noia')}
            className="group flex flex-col items-center cursor-pointer"
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            whileHover={{ scale: 1.12, y: -20 }}
            whileTap={{ scale: 0.95 }}
          >
            <motion.div 
              className="relative transition-all duration-300 group-hover:brightness-110"
              style={{
                filter: 'drop-shadow(0 20px 25px rgba(0,0,0,0.25))'
              }}
            >
              {/* Glow effect behind the book */}
              <div 
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 blur-2xl -z-10"
                style={{
                  background: 'radial-gradient(circle, rgba(245, 158, 11, 0.5) 0%, transparent 70%)',
                  transform: 'scale(1.3)'
                }}
              />
              <img
                src={MOCKUP_GIRL}
                alt="Protagonista noia"
                className="w-36 sm:w-52 lg:w-64 transition-all duration-300"
              />
            </motion.div>
          </motion.button>
        </div>

{/* Removed redundant text - instruction is now prominent above */}
      </main>
    </div>
  );
}
